import React, { PropsWithChildren, ReactElement } from "react";
import DefaultLayout from "common/Layouts/Default/Default";
import Header from "common/Header/Header";
import Footer from "common/Footer/Footer";
import NavigationBar from "common/NavigationBar/NavigationBar";

type Props = PropsWithChildren<{
  layout?: Components.Layout;
  header?: ReactElement;
  footer?: ReactElement;
  navBar?: ReactElement;
}>;

const PageContainer: React.FC<Props> = ({
  layout: Layout = DefaultLayout,
  header = <Header />,
  footer = <Footer />,
  navBar = <NavigationBar />,
  children,
}: Props) => {
  return (
    <Layout
      header={header}
      content={children}
      footer={footer}
      navBar={navBar}
    />
  );
};

export default PageContainer;
